import { projectContext } from '@/layouts/MainLayout'
import { getProjectTasks } from '@/services/task/task'
import { listToTree } from '@/utils/utils'
import { useRequest } from 'ahooks'
import { TreeSelect } from 'antd'
import { memo, useContext, useState } from 'react'

const TaskTreeSelect = memo((props: any) => {
  const { taskId, ...otherProps } = props
  const { projectType, projectId } = useContext(projectContext)
  const [taskTree, setTaskTree] = useState<any[]>([])
  useRequest(() => getProjectTasks(projectType, projectId), {
    onSuccess: ([data]) => {
      const target = data.find((item) => item.id === taskId)
      const disabledIds: number[] = []
      if (target) {
        disabledIds.push(target.id)
        // parent ids
        let pid = target.parentId
        while (pid) {
          const parentTask = data.find((item) => item.id === pid)
          if (parentTask) {
            disabledIds.push(pid)
            pid = parentTask.parentId
          }
        }
        // children ids
        const eachChild = (targetId) => {
          const childTasks = data.filter((item) => item.parentId === targetId)
          childTasks?.forEach((item) => {
            disabledIds.push(item.id)
            eachChild(item.id)
          })
        }
        eachChild(target.id)
      }
      const nodes = data.map((item) => {
        const { name, id, parentId } = item
        return {
          id,
          parentId,
          label: name,
          value: id,
          selectable: !disabledIds.includes(id)
        }
      })
      setTaskTree(listToTree(nodes))
    }
  })

  return (
    <TreeSelect
      {...otherProps}
      style={{ width: '100%' }}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      treeData={taskTree}
      placeholder='Please select'
      treeDefaultExpandAll
    />
  )
})

export default TaskTreeSelect
